<div class="base-container">
  <navigation></navigation>
  <div class="container" style="background: #fff">
    <div class="main-layout" authorize-context [resource]="'ADMIN'">
      <menu></menu>
      <section class="main-content">
        <router-outlet></router-outlet>
      </section>
    </div>
  </div>
</div>
